import LastMessageTransformer from "./list-last-message-transformer";
import QuoteEstimateTransformer from "./list-quote-estimate-transformer";
import ReviewStars from "./review-stars";
import { SellerListCard } from "../components/seller-list-card/SellerListCard";

export default function () {
	const lastMessageTransformer = LastMessageTransformer();
	const quoteEstimateTransformer = QuoteEstimateTransformer();

	const state = {
		projectDetail: null,
		buyerDetails: null,
		bookings: null,
	};

	const buildPublicLink = (
		url_public_path,
		linkListType,
		{
			bpvsid,
			bpvid,
			projectHash,
			isEnquiry,
			isBookNowEnabled,
			isMarketplaceCardEnquiry,
			isMarketplaceCardMessage,
			isMarketplaceSeparatedList,
			bookingRequest,
			pendingBookingRequest,
		},
	) => {
		const categoryId = $('#cat-id').length ? $('#cat-id').val() : null;
		const enquiryParam = isEnquiry ? `&enquiry=${isEnquiry}` : '';
		const bookNowParam = isBookNowEnabled ? `&bookNow=${isBookNowEnabled}` : '';
		const marketplaceCard = isMarketplaceCardEnquiry ? `&marketplaceEnquiry=1` : '';
		const marketplaceMessage = isMarketplaceCardMessage ? `&marketplaceMessage=1` : '';
		const marketplaceSeparatedList = isMarketplaceSeparatedList
			? `&marketplaceSeparatedList=1`
			: '';
		const pendingBookingRequestParam = pendingBookingRequest
			? `&pendingBookingRequest=1`
			: '';
		const bookingRequestParam = bookingRequest ? `&bookingRequest=1` : '';

		let publicLink =
			linkListType === 'project_sellers'
				? `${url_public_path}?prid=${projectHash}&bpvsid=${bpvsid}&bpvid=${bpvid}${enquiryParam}${bookNowParam}${marketplaceCard}${marketplaceMessage}${marketplaceSeparatedList}${bookingRequestParam}${pendingBookingRequestParam}`
				: linkListType === 'browse_sellers'
				? `${url_public_path}?caid=${categoryId}`
				: `${url_public_path}?`;
		return publicLink;
	};

	/**
	 *
	 * @param attributes object Seller' data object from api
	 * @param sellerProfileId  string hashed spid
	 * @param projectHash string hash of project id
	 * @param projectDetail  object project data from API -- this will contain an `experiments` attribute that can be used to modify the seller cards
	 * @param buyerDetails object buyer data from api
	 * @param bpvid
	 * @param separationListVariant Separation list variant
	 * @returns string html for a seller row
	 */
	const buildSellerHtml = (
		{
			attributes,
			type,
			id: sellerProfileId,
			hbTemplateId: hbTemplateId,
			linkListType: linkListType = 'seller-list',
			projectHash = null,
		},
		{ projectDetail, buyerDetails, bpvid = null, bookings },
		isResponsesList,
		isMarketplaceSeparatedList = false,
	) => {
		state.projectDetail = projectDetail;
		state.buyerDetails = buyerDetails;
		state.bookings = bookings;

		const { reviews_score, url_public_path, last_message } = attributes;

		const bpvsid = attributes?.bpvsid;
		const project_response_id = attributes?.project_response_id;
		const messenger_slug = state.projectDetail.attributes?.slug;

		attributes.formatted_last_message = lastMessageTransformer.formatMessage(
			last_message,
			attributes.company_name,
		);
		attributes.formatted_quote = quoteEstimateTransformer.formatEstimate(
			attributes.quote,
		);
		attributes.messenger_link = `/buyers/messenger/${messenger_slug}/?`;

		if ('undefined' !== messenger_slug && null != messenger_slug) {
			attributes.messenger_link = `/buyers/messenger/${messenger_slug}/?`;

			if ('undefined' !== project_response_id) {
				attributes.messenger_link += `&r=${project_response_id}`;
			}
			if ('undefined' !== bpvsid && null != bpvsid) {
				attributes.messenger_link += `&bpvs=${attributes.bpvsid}`;
			}
		}

		attributes.messenger_link = _l(attributes.messenger_link);

		const isEnquiry = ['enquiry', 'marketplace-enquiry'].some((r) =>
			attributes?.match_types.includes(r),
		)
			? 1
			: 0;

		const isBookNowEnabled = ['booking', 'marketplace-booking'].some((r) =>
			attributes?.match_types.includes(r),
		)
			? 1
			: 0;

		const isBookingExperimentOn = document.getElementById('ebb-enabled')?.value === '1';

		function isBooking() {
			if (!isBookingExperimentOn) {
				return null;
			}

			if (isResponsesList) {
				return (
					bookings?.find(
						(b) =>
							b.attributes.seller_profile_id.toString() === attributes.sp_id.toString(),
					)?.attributes ?? null
				);
			}

			return null;
		}

		const bookingRequest = ['booking-request'].some((r) =>
			attributes?.match_types.includes(r),
		)
			? 1
			: 0;

		const pendingBookingRequest = !!attributes?.customer_order?.state;

		const associatedBooking = isBooking();

		const isMarketplaceCardEnquiry = ['marketplace-enquiry'].some((r) =>
			attributes?.match_types.includes(r),
		);

		const isMarketplaceCardMessage = ['marketplace-messages'].some((r) =>
			attributes?.match_types.includes(r),
		);

		const publicLink = _l(
			buildPublicLink(url_public_path, linkListType, {
				bpvsid,
				bpvid,
				projectHash,
				isEnquiry,
				isBookNowEnabled,
				isMarketplaceCardEnquiry,
				isMarketplaceCardMessage,
				isMarketplaceSeparatedList,
				bookingRequest,
				pendingBookingRequest,
			}),
		);
		const sellerData = {
			...attributes,
			...buildSellerListCardAttributes(
				attributes,
				isEnquiry,
				isBookNowEnabled,
				isMarketplaceCardEnquiry,
				isMarketplaceCardMessage,
				bookingRequest,
				pendingBookingRequest,
			),
			id: sellerProfileId,
			publicLink,
			project: state.projectDetail,
			starsHtml: ReviewStars().generateStars(reviews_score),
			email_address: state.buyerDetails.data.email,
			telephone_number: state.buyerDetails.data.telephone,
			associatedBooking,
			location: {
				location_display_string: attributes?.location_display_string,
				location_distance: attributes?.location_distance,
				is_multi_location: attributes?.is_multi_location,
				is_online_only: attributes?.is_online_only,
				is_no_location: attributes?.is_no_location,
			},
		};

		//Manually add exp data to sellerListCardExperiments
		const sellerListCardExperiments = projectDetail?.attributes?.experiments?.concat([
			{
				name: 'separation_list_ctas',
				isMarketplaceSeparatedList,
			},
		]);

		try {
			return new SellerListCard(sellerData, {
				experiments: sellerListCardExperiments,
				cardType: type === 'bookable_sellers' ? 'bookable' : 'primary',
			}).outputCardHtml();
		} catch (e) {
			console.log(e);
			bugsnagClient &&
				bugsnagClient.notify(new Error('error compiling template'), {
					metaData: { error: e },
				});
		}
	};

	const buildSellerListCardAttributes = (
		attributes,
		isEnquiry,
		isBookNowEnabled,
		isMarketplaceEnquiry,
		isMarketplaceMessage,
		bookingRequest,
		pendingBookingRequest,
	) => {
		const isEbbEnabled = document.getElementById('ebb-enabled')?.value === '1';
		const isMarketplaceMessagingEnabled =
			document.getElementById('marketplace-messaging-enabled')?.value === '1';
		const isCallbackType = isBookNowEnabled && isEbbEnabled;

		const isBookingRequestRequired = bookingRequest;

		return {
			vetted: attributes?.is_bark_vetted,
			elite: attributes?.avatar?.elite,
			quoteContent: attributes?.formatted_quote
				? {
						value: attributes?.formatted_quote.value,
						type: attributes?.quote.type === 'onceoff' ? null : attributes.quote.type,
				  }
				: null,
			labels:
				[
					{ callbacksEnabled: isEnquiry || isCallbackType || isMarketplaceMessage },
					...attributes?.labels,
				] ?? [],
			categories:
				getCategoriesForDisplay(
					attributes?.top_categories,
					state?.projectDetail?.attributes.category,
				) ?? [],
			description: attributes?.profile_text,
			isEbbEnabled: !isBookingRequestRequired && isEbbEnabled,
			enquiry: !isBookingRequestRequired && isEnquiry, //Show Call Now cta
			showContactNowCta:
				!isBookingRequestRequired &&
				isMarketplaceMessagingEnabled &&
				(isMarketplaceEnquiry || isMarketplaceMessage), // Show Contact Now cta
			callbacksEnabled: !isBookingRequestRequired && isCallbackType,
			isMarketplaceEnquiry: !isBookingRequestRequired && isMarketplaceEnquiry,
			isMarketplaceMessage: !isBookingRequestRequired && isMarketplaceMessage,
			isMarketplaceCard:
				!isBookingRequestRequired &&
				(isEnquiry || isCallbackType || isMarketplaceMessage),
			showGreatMatchStyle: ['enquiry'].includes(attributes?.match_type),
			bookingRequest: bookingRequest,
			pendingBookingRequest: pendingBookingRequest,
		};
	};

	const getCategoriesForDisplay = (top_categories, projectCategory) => {
		if (!top_categories && !projectCategory) {
			return [];
		}

		if (!top_categories) {
			top_categories = [];
		}

		let categoryNames = [];
		for (let category of top_categories) {
			categoryNames.push(category);
		}
		const projectCategoryIndex = categoryNames.indexOf(projectCategory.name);
		if (projectCategoryIndex < 0 || projectCategoryIndex > 2) {
			categoryNames.splice(2, 1, projectCategory.name);
		}
		return categoryNames.length > 3 ? categoryNames.splice(0, 3) : categoryNames;
	};

	return {
		buildSellerHtml,
	};
}
